import PermissionTools from './container';

export default PermissionTools;
